import HashtagIcon from "assets/icons/Hashtag";
import { formatPrice, getDefaultCurrency } from "helpers";
import { useRef } from "react";
import { store } from "store/store";

const usePrintInstallment = (args: { installments: any, index: number }) => {
    const { installments, index } = args
    const { getState } = store
    const business = getState().businessReducer.business.business;
    const contentRef = useRef<any>(null);
    let content = <></>;
    if (installments) {
        content = <div
            className="bg-white flex flex-col items-center text-black p-5"
            ref={contentRef}
            style={{ direction: "rtl", lineHeight: '30px' }}
        >


            <div className="w-full row border-t-2 border-r-2 border-l-2  border-[#000]">
                <div className="flex justify-between  ">
                    <div>
                        <div className="flex flex-row">
                            <p>تاریخ : </p>
                            <p className="mr-3">{
                                installments.date
                            }</p>
                        </div>
                        <div className="flex flex-row">
                            <p> پرداخت کننده : </p>
                            <p className="mr-3">{
                                installments.Person.nickName
                            }</p>
                        </div>
                        <div className=" flex flex-row">
                            <p></p>
                        </div>
                        <div className="flex flex-row">
                            <p>توضیحات اقساط:</p>
                            <p className="mr-3">{installments.description}</p>
                        </div>

                    </div>
                    <div className="">
                    <div className="text-[20px] font-extrabold text-center pb-1">دفترچه قسط</div>
                    <div className="text-[16px] font-extrabold text-center pb-1">{business.legalName}</div>
                </div>
                    <div className="flex flex-col">
                        <div className="text-[16px] text-left pb-1 flex">
                            {/* <p>
                                شماره قسط:
                            </p>
                            <p>
                                {installments.code}
                            </p> */}
                        </div>
                        <div className="text-[16px] text-left pb-1 flex">
                            <p>تعداد اقساط:</p>
                            <p className="mr-3">{installments.quantity}</p>
                        </div>
                        <div className="text-[16px] text-left pb-1 flex">
                            <p>مبلغ کل اقساط:</p>
                            <p className="mr-3">{
                                `${formatPrice(installments.totalPaid)} ${getDefaultCurrency(installments.CurrencyId).en_title}`
                            }</p></div>
                    </div>
                </div>
            </div>

            <div className="w-full row   ">
                <table
                    className="w-full table-bordered border-2 border-[#000]" style={{ lineHeight: '30px' }}>
                    <thead>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}>
                            ردیف
                        </th>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}>شرح قسط
                        </th>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}
                            className="w-[140px]">تاریخ قسط
                        </th>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}>مبلغ قسط
                        </th>

                    </thead>
                    <tbody>
                        {
                            installments?.Installment_Items?.map((item: any, i: number) => {
                                return (
                                    <tr key={i}>
                                        <td className="text-center font-semibold" style={{
                                            borderLeft: "2px solid black",
                                            borderBottom: "2px solid black",
                                            padding: "3px",
                                            textAlign: 'center'
                                        }}>{i + 1}</td>
                                        <td className="px-0 py-1"
                                            style={{
                                                borderLeft: "2px solid black",
                                                borderBottom: "2px solid black",
                                                padding: "3px",
                                                textAlign: 'center'
                                            }}>
                                            <p className="text-xs font-semibold">{item.title}</p>
                                        </td>
                                        <td style={{
                                            borderLeft: "2px solid black",
                                            borderBottom: "2px solid black",
                                            padding: "3px",
                                            textAlign: 'center'
                                        }}>
                                            <span className="flex justify-center">{item.dueDate}</span>
                                        </td>
                                        <td style={{
                                            borderLeft: "2px solid black",
                                            borderBottom: "2px solid black",
                                            padding: "3px",
                                            textAlign: 'center'
                                        }}>
                                            <span>{item.isCreditor ? 0 : formatPrice(item.price)}</span>
                                        </td>

                                    </tr>
                                );
                            })
                        }
                       
                    </tbody>
                </table>
            </div>
        </div>
    }
    return { content, contentRef };
}

export default usePrintInstallment;